import { SVGProps } from 'react';

const GooglePayIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      {...props}
      width="132"
      height="24"
      viewBox="0 0 132 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M63.9549 11.7388V18.7344H61.6982V1.43328H67.5656C68.9948 1.43328 70.3488 1.95984 71.4019 2.93773C72.455 3.8404 72.9816 5.1944 72.9816 6.62363C72.9816 8.05285 72.455 9.33164 71.4019 10.3095C70.3488 11.2874 69.07 11.814 67.5656 11.814H63.9549V11.7388ZM63.9549 3.53951V9.5573H67.716C68.5435 9.5573 69.3709 9.25641 69.8975 8.65463C71.101 7.5263 71.101 5.64574 69.8975 4.5174C69.2957 3.8404 68.5435 3.46429 67.716 3.53951H63.9549Z"
        fill="#5F6368"
      />
      <path
        d="M78.1718 6.5484C79.8267 6.5484 81.1054 6.99974 82.0833 7.9024C83.0612 8.80507 83.5126 10.0086 83.5126 11.5131V18.7344H81.4063V17.0795C80.5037 18.4335 79.2249 19.1105 77.7204 19.1105C76.216 19.1105 75.3133 18.7344 74.4106 17.9822C73.5832 17.23 73.0566 16.1769 73.0566 15.0485C73.0566 13.9202 73.508 12.8671 74.4106 12.1149C75.3133 11.3626 76.5921 11.0617 78.0965 11.0617C79.601 11.0617 80.5037 11.2874 81.3311 11.814V11.2874C81.3311 10.5352 81.0302 9.78296 80.4284 9.33163C79.8267 8.80507 79.0744 8.50418 78.247 8.50418C76.9682 8.50418 75.9903 9.03074 75.3133 10.0839L73.3575 8.8803C74.5611 7.30062 76.1408 6.5484 78.247 6.5484H78.1718ZM75.3133 15.1238C75.3133 15.7255 75.6142 16.2521 76.0655 16.553C76.5921 16.9291 77.1939 17.1548 77.7957 17.1548C78.6983 17.1548 79.601 16.7787 80.278 16.1016C81.0302 15.4246 81.4063 14.5972 81.4063 13.6945C80.7293 13.168 79.7514 12.8671 78.4727 12.8671C77.1939 12.8671 76.8178 13.0928 76.216 13.5441C75.6142 13.9202 75.3133 14.4468 75.3133 15.1238Z"
        fill="#5F6368"
      />
      <path
        d="M95.6986 6.9245L88.2516 24H85.9949L88.7781 18.0574L83.8887 6.99972H86.2958L89.8312 15.4999L93.2915 6.99972H95.6234L95.6986 6.9245Z"
        fill="#5F6368"
      />
      <path
        d="M55.0034 10.2343C55.0034 9.55731 54.9282 8.88031 54.853 8.20331H45.4502V12.0397H50.791C50.5653 13.2432 49.8883 14.3715 48.8352 15.0485V17.5309H52.0698C53.9503 15.8008 55.0034 13.2432 55.0034 10.2343Z"
        fill="#4285F4"
      />
      <path
        d="M45.4505 19.938C48.1585 19.938 50.4151 19.0353 52.07 17.5309L48.8355 15.0485C47.9328 15.6503 46.8045 16.0264 45.4505 16.0264C42.8929 16.0264 40.6362 14.2963 39.884 11.8892H36.5742V14.4467C38.3043 17.8317 41.6893 19.938 45.4505 19.938Z"
        fill="#34A853"
      />
      <path
        d="M39.8837 11.8892C39.4323 10.6856 39.4323 9.33159 39.8837 8.05281V5.49525H36.5739C35.1446 8.27848 35.1446 11.5883 36.5739 14.4467L39.8837 11.8892Z"
        fill="#FBBC04"
      />
      <path
        d="M45.3752 3.91561C46.8045 3.91561 48.1585 4.44217 49.2116 5.42006L52.07 2.56161C50.2647 0.906716 47.8576 -0.0711753 45.4505 0.00404707C41.6893 0.00404707 38.2291 2.11027 36.5742 5.49528L39.884 8.05285C40.561 5.64573 42.8177 3.91561 45.3752 3.91561Z"
        fill="#EA4335"
      />
    </svg>
  );
};

export default GooglePayIcon;
